// Generated by CoffeeScript 1.12.7
(function() {
  module.exports = {
    'Content-Type': 'application/vnd.api+json',
    'Accept': 'application/vnd.api+json'
  };

}).call(this);
